export default "__VITE_ASSET__BSy$wlTS__"